import React from "react";
import { TTeamMember } from "../../../resources";

const TeamItem = ({ id, name, image, value }: TTeamMember) => {
  return (
    <div className="bg-black flex w-full relative">
      {image ? (
        <img
          src={image}
          className="w-full h-full object-cover opacity-20 relative"
          alt={name}
        />
      ) : (
        <img
          src={
            "https://res.cloudinary.com/dkyl4jbxx/image/upload/v1628107234/mementry/mementry_avatar.png"
          }
          className="w-full h-full object-cover opacity-20 relative"
          alt={name}
        />
      )}
      {/* <img src={image} className="w-full h-full object-cover opacity-20 relative" alt={name}/> */}
      <div className="absolute flex flex-row items-start justify-center bottom-0 z-10 flex-grow space-x-3">
        {image ? (
          <img
            src={image}
            className="h-24 aspect-square object-cover relative shadow-lg"
            alt={name}
          />
        ) : (
          <img
            src={
              "https://res.cloudinary.com/dkyl4jbxx/image/upload/v1628107234/mementry/mementry_avatar.png"
            }
            className="h-24 aspect-square object-cover relative shadow-lg"
            alt={name}
          />
        )}
        <div className="flex flex-col items-start justify-start flex-grow">
          <p className="text-left italic font-bold text-6xl -mb-2">{value}</p>
          <p className="text-bold text-xl italic leading-5">{name}</p>
        </div>
      </div>
    </div>
  );
};

export default TeamItem;
